export const PAYMENT_METHODS = Object.freeze({
  APPLE_PAY: 'apple_pay',
  LINE_PAY: 'line_pay',
  CREDIT_CARD: 'credit_card',
  EASY_WALLET: 'easy_wallet',
  JKOPAY: 'jkopay',
  AUTOPASS: 'autopass',
  AUTOPASS_PARTNER: 'auto_partner',
});

export const PAYMENT_METHODS_NAME = Object.freeze({
  [PAYMENT_METHODS.APPLE_PAY]: 'Apple Pay',
  [PAYMENT_METHODS.LINE_PAY]: 'LINE Pay',
  [PAYMENT_METHODS.EASY_WALLET]: '悠遊付',
  [PAYMENT_METHODS.JKOPAY]: '街口支付',
  [PAYMENT_METHODS.CREDIT_CARD]: '信用卡',
  [PAYMENT_METHODS.AUTOPASS]: 'Autopass',
  [PAYMENT_METHODS.AUTOPASS_PARTNER]: 'Autopartner',
});

export const CAPTURE_TYPES = Object.freeze({
  AUTO: 'automatic',
  MANUAL: 'manual',
});

export const CAPTURE_TYPES_NAME = Object.freeze({
  [CAPTURE_TYPES.AUTO]: '直接請款',
  [CAPTURE_TYPES.MANUAL]: '預授權',
});

export const PAYMENT_STATE = Object.freeze({
  PAID: 'paid',
  UNPAID: 'unpaid',
  PENDING: 'pending',
});
